module.exports = __webpack_public_path__ + "static/media/ledgerlink.ed6a8017.svg";